import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
function PaymentPage() {
    const location = useLocation();
    const [trxId, setTrxId] = useState();
    const [nestPayReady, setNestPayReady] = useState(false);
    const [isMounted, setMounted] = useState();
    const navigate = useNavigate();
    useEffect(() => {
        setMounted(true);
    }, [])
    useEffect(() => {
        if (isMounted) {
            setNestPayReady(true);
        }
    }, [isMounted])

    useEffect(() => {
        if (nestPayReady && location && location.state) {
            const jsUrl = "https://tapi.nestpay.co.kr/static/v1/public/nestpay.v1.js";
            const jsElement = document.createElement("script");
            jsElement.src = jsUrl + "?ver=" + new Date().getTime();
            if (!window._babelPolyfill) { // babel-polyfill이 이미 로드되었는지 확인
                
                setTrxId(location.state.data.link.trxId);
                jsElement.onload = () => {
                    
                    if (window.NESTPAY) {
                        window.NESTPAY.welcome();
                        window.NESTPAY.pay({
                            payMethod: "card",
                            trxId: location.state.data.link.trxId,
                            openType: 'layer',
                            onApprove: function (response) {

                                if (response.resultCd === "0000") {
                                    // navigate("/test2/payment/complete");

                                    window.location.replace(`/ws/${location.state.data.link.udf1}/homepage/payment/gateway?type=product&orderId=${location.state.data.link.trackId}&amount=${location.state.data.link.amount}&storeCode=${location.state.data.link.udf1}`);
                                } else {
                                    // navigate(`/ws/${location.state.data.link.udf1}/homepage/payment/fail`, {state: {storeCode : location.state.data.link.udf1}});
                                    window.location.href = `/ws/${location.state.data.link.udf1}/homepage/payment/fail`;
                                    // window.location.replace('http://localhost:3000/ws/5/home');
                                }

                            }
                        });
                    }
                };
                document.head.appendChild(jsElement);
                return () => {
                    document.head.removeChild(jsElement);
                };


            }
        }
    }, [nestPayReady, location]);

    return (
        <div></div>

    );
}

export default PaymentPage;